<section class="record">
    <span ng-click="toggleDetails()">
        <span class="details-toggle" ng-class="{open:showDetails}"><i class="fa fa-angle-right"></i></span>
        <span c-activity-log-blurb activity="activity"></span>
        <span>
            {{header}}
        </span>
    </span>
</section>
<section class="details" c-toggle="showDetails">
    <section class="recipients-section response-details">
        <div>{{"transcriptResponseLog.recipient"|translate}}: {{recipient}}</div>
        <div>
            <span>{{"transcriptResponseLog.from"|translate}}</span>
            <span class="response">{{oldResponseType}}</span>
            <span>{{"transcriptResponseLog.to"|translate}}</span>
            <span class="response">{{newResponseType}}</span>
        </div>
    </section>
</section>